import { createRouter, createWebHistory } from 'vue-router'
import { routes } from '@/pages'
import { runMiddlewarePipeline } from './middleware'
import { useActiveChannelStore } from '@/entities/channel'

// Register all middleware (side-effect imports)
import './guards/auth.guard'
import './guards/guest.guard'
import './guards/role.guard'
import './guards/channel.guard'

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }

    return { top: 0 }
  },
})

// Run middleware pipeline based on route meta.middleware
router.beforeEach(runMiddlewarePipeline)

// Clear active channel when leaving channel routes
router.afterEach((to) => {
  if (!to.params.channelId) {
    const store = useActiveChannelStore()
    if (store.activeChannelId) {
      store.clearChannel()
    }
  }
})
